import { connect } from "react-redux"
import { getOfferStartDateString } from "utilities/time"
import routeNames from "components/navigators/constants"
import { offerRequestSelected } from "modules/Seller/OfferRequests/actions"
import { offerSelected } from "modules/Seller/Offers/actions"
import _ from "lodash"
import View from "./view"
import { Store } from "utilities/Redux/store"
import { Navigation } from "components/types"
import { getSellerOfferById } from "modules/Seller/Offers/selectors"
import { getBuyerProfileForId } from "modules/BuyerProfiles/selectors"
import { getCategoryById } from "modules/Buyer/Categories/selectors"
import { getOfferRequestByIdForSeller } from "modules/Seller/OfferRequests/selectors"
import { getLocaLizedName } from "utilities/Redux/normalizeHelpers"
import { getUnseenMessagesCountForChat } from "modules/ChatMessages/selectors"

interface OwnProps {
  id: string
  navigation: Navigation
}

const mapStateToProps = (state: Store, ownProps: OwnProps) => {
  const offer = getSellerOfferById(state, ownProps.id)
  const offerRequest =
    offer && getOfferRequestByIdForSeller(state, offer.offerRequest)
  const category = offerRequest && getCategoryById(state, offerRequest.category)
  const buyerProfile =
    offerRequest && getBuyerProfileForId(state, offerRequest.buyerProfile)
  const unseenMessages = offer
    ? getUnseenMessagesCountForChat(state, offer.chat)
    : 0
  return {
    offer,
    offerRequest,
    buyerProfile,
    category,
    unseenMessages,
  }
}

const mapDispatchToProps = {
  offerRequestSelected,
  offerSelected,
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
  ownProps: OwnProps,
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onPress: () => {
    if (stateProps.offerRequest && stateProps.category && stateProps.offer) {
      dispatchProps.offerRequestSelected(stateProps.offerRequest.id)
      dispatchProps.offerSelected(ownProps.id)

      ownProps.navigation.navigate(
        routeNames.SELLER.OPEN_OFFER_REQUEST_DETAILS,
        {
          name: `${getLocaLizedName(
            stateProps.category.name,
          )} ${getOfferStartDateString(stateProps.offer)}`,
        },
      )
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(View)
